import type { FrontendWidget } from '../types';
import { ReviewsWidgetComponent } from './ReviewsWidgetComponent';
import type { ReviewsWidgetConfig, ReviewsWidgetResolved } from './types';

export const reviewsWidget: FrontendWidget<
  ReviewsWidgetConfig,
  ReviewsWidgetResolved
> = {
  componentType: 'widgets.reviews',
  displayName: 'Reviews',
  ComponentA: ReviewsWidgetComponent,
  // No resolveSync — lookup widget. Resolved data arrives via POST /api/resolve-widgets
  // or, on SSR page loads, already attached by RenderPageService/ReviewsResolver.
};
